module.exports = __webpack_public_path__ + "img/c07-min.00dcb0f4.png";